module.exports = __webpack_public_path__ + "9653d0ed92db82664cd3a5baa453065f.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/stones-throw.jpg
 ** module id = 448
 ** module chunks = 0
 **/